<template>
	<div>
		<div class="card">
			<div class="card-title">推荐</div>
			<ul class="card-cnt">
				<li @click="toDetail(item)" v-for="item in list">{{item.title}}</li>
			</ul>
		</div>
		<div class="card">
			<div class="card-title">推荐</div>
			<a :href="item.linkRoute" v-for="item in imgList" :key="item.id">
				<img :src="item.picUrl" class="recommend-img" />
			</a>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Recommend',
		props: {
			list: {
				type: Array,
				value: []
			},
			imgList: {
				type: Array,
				value: []
			},
			keyCode: {
				type: String,
				value: ''
			},
			navId: {
				type: String,
				value: ''
			}
		},
		methods: {
			toDetail(item){
				this.$emit('toDetail', {
					id: item.id,
					linkRoute: item.linkRoute||''
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.card{
		width: 380px;
		min-height: 221px;
		background:#fff;
		margin-bottom: 20px;
		padding: 14px 23px 20px;
		border-radius: 5px;
		box-sizing: border-box;
		.card-title{
			height: 40px;
			border-bottom: 1px solid #e5e6e9;
			font-size: 16px;
			letter-spacing: .57px;
			text-align: justify;
			font-weight: 600;
			line-height: 40px;
		}
		.card-line{
			width: 100%;
			height: 1px;
			background: #e5e6e9;
			margin-top: 7px;
		}
		.card-cnt li{
			height: 20px;
			margin-top: 13px;
			font-size: 14px;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
			word-wrap: normal;
			text-align: justify;
			cursor: pointer;
		}
		.card-cnt li:hover{
			
		}
		.recommend-img{
			width: 334px;
			height: 187px;
		}
	}
</style>
